import { render } from "./LabelContentDocumentTypePage.vue?vue&type=template&id=fdb7ec70&ts=true"
import script from "./LabelContentDocumentTypePage.ts?vue&type=script&lang=ts&external"
export * from "./LabelContentDocumentTypePage.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__